import { Icon } from 'gu-ui-kit'
import React from 'react'

export default () => {
  return {
    initial: {
      query: '',
      status: '',
    },
    configuration: {
      query: {
        subbutton: { isVisible: (value = '') => !!value },
        label: 'agency::filters.dropdown.items.query.label',
        placeholder: 'agency::filters.input.placeholder',
        order: 1,
        type: 'input',
      },
      status: {
        subbutton: {
          isVisible: (value = [], breakpoints) =>
            value.length > 0 || !!breakpoints.fb,
        },
        icon: (
          <Icon
            name={'avatar1'}
            size={'s'}
            bgColor={'secondary-33'}
            color={'basic-primary-white'}
          />
        ),
        label: 'agency::filters.dropdown.items.status.label',
        position: 'dropdown',
        type: 'radio group',
        optionLabelPrefix: 'agency::filters.dropdown.items.status.options.',
        options: ['new', 'declined'],
      },
    },
  }
}
